module.exports = __webpack_public_path__ + "static/img/logo_cgw.f039f44a.png";